// Температура лида и TG-аккаунта: аккаунт с температурой работает только с
// лидами той же температуры, если в настройках первого сообщения включён
// переключатель «Только своя температура» (по аналогии с гео-пулом).

export const TEMPERATURE_VALUES = ['cold', 'warm', 'hot'] as const

export type LeadTemperature = typeof TEMPERATURE_VALUES[number]

export const DEFAULT_TEMPERATURE: LeadTemperature = 'cold'

export const TEMPERATURE_OPTIONS = [
    { value: 'cold', label: 'Cold' },
    { value: 'warm', label: 'Warm' },
    { value: 'hot', label: 'Hot' },
]

export const TEMPERATURE_COLORS: Record<string, string> = {
    cold: '#3b82f6',
    warm: '#eab308',
    hot: '#ef4444',
}

export function temperatureColor(value?: string | null, fallback = 'transparent'): string {
    return TEMPERATURE_COLORS[(value || '').toLowerCase()] || fallback
}

export function temperatureLabel(value?: string | null): string {
    return TEMPERATURE_OPTIONS.find((option) => option.value === (value || '').toLowerCase())?.label || '-'
}

// Порядок для сортировки: cold -> warm -> hot, пустая температура уходит в конец.
export function temperatureRank(value?: string | null): number {
    const index = TEMPERATURE_VALUES.indexOf((value || '').toLowerCase() as LeadTemperature)
    return index === -1 ? TEMPERATURE_VALUES.length : index
}
